import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, FloatingLabel, Form, Stack, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Karaoke = (props) => {
    const [books, setBooks] = useState([])
    const [bookRaw, setBookRaw] = useState('')
    const [loader, setLoader] = useState(false)
    const [bookRawView, setBookRawView] = useState('')
    const [currentMode, setCurrentMode] = useState('words')
    const editorRef = useRef(null)
    const [bookForSave, setBookForSave] = useState({})
    const URL_PREFIX = 'http://kitap.alsu.tatar';


    useEffect(() => {
        let b = axios.get(`${URL_PREFIX}/api/karaoke/adminlist`).then(b => {
            setBooks(b.data.message)
        })
    }, [])
    useEffect(() => {
        console.log(bookRaw)
    }, [bookRaw])

    useEffect(() => {
        console.log(bookForSave)
    }, [bookForSave])

    function deleteBook(id) {
        axios.get('http://kitap.alsu.tatar/api/karaoke/delete/' + id).then((response) => {
            console.log(response.data);
            setBooks(response.data.message)
        })
    }

    function changeRawData(data) {
        let tmp = '[' + data + ']'
        tmp = tmp.replaceAll('" }', '"}')
        tmp = tmp.replaceAll('word', '"word"')
        tmp = tmp.replaceAll('start', '"start"')
        tmp = tmp.replaceAll('},]', '}]')
        console.log(tmp)
        setBookRaw(JSON.parse(tmp))
        setBookRawView(data)
        setBookForSave({...bookForSave, rawData: JSON.stringify(tmp), title: '', author: '', audio: {}})
    }

    async function saveBook() {
        console.log('111', bookForSave)
        console.log('222', bookRaw)

        if (bookForSave._id) {
            let answer = await axios.post(`${URL_PREFIX}/api/karaoke/edit`, bookForSave).catch(e => {
                console.log('err', e)
                return
            })

            setBookForSave({})
            setBookRaw('')
            setBookRawView('')
            let b = await axios.get(`${URL_PREFIX}/api/karaoke/adminlist`)
            setBooks(b.data.message)
            console.log('333', b.data.message)
        } else {
            let obj = {...bookForSave}
            obj.rawData = JSON.stringify(bookRaw)
            let answer = await axios.post(`${URL_PREFIX}/api/karaoke/create`, obj).catch(e => {
                console.log(e)
                return
            })
            console.log('444', answer.data)

            let b = await axios.get(`${URL_PREFIX}/api/karaoke/adminlist`)
            setBooks(b.data.message)
            setBookForSave({})
            setBookRaw('')
            setBookRawView('')
        }

    }

    async function saveFileToStorage(event, mode) {

        let answer = await on_form_submit(event)
        console.log(answer)
        let paths = []
        answer.data.forEach((item) => {
            paths.push(item.path)
        })
        if (mode === 'cover') {
            setBookForSave({...bookForSave, cover: paths[0]})
        }
        if (mode === 'body') {
            let tmp = {...bookForSave.audio}
            tmp.body = paths[0]
            setBookForSave({...bookForSave, audio: tmp})
        }
        if (mode === 'title') {
            let tmp = {...bookForSave.audio}
            tmp.title = paths[0]
            setBookForSave({...bookForSave, audio: tmp})
        }
    }

    function addEmptyQuestion() {
        let tmp = bookForSave.test
        tmp.push({
            question: '',
            answers: [
                {answer: '', correct: false},
                {answer: '', correct: false},
                {answer: '', correct: false},
            ]
        })
        setBookForSave({...bookForSave, test: tmp})
    }

    function editItem(index) {
        let data = books[index]
        console.log(data)
        setBookForSave(data)
        setBookRaw(data.karaoke)
        let tmp = data.rawData
        tmp = tmp.replaceAll('[', '')
        tmp = tmp.replaceAll(']', '')
    }

    // @ts-ignore
    const on_form_submit = async (e, path) => {
        e.preventDefault();
        setLoader(true)
        console.log(Array.prototype.slice.call(e.target.files))
        let data = new FormData();
        // @ts-ignore
        Array.prototype.slice.call(e.target.files).forEach(file => {
            data.append('files', file);
        })
        var config = {
            method: 'post',
            url: 'http://kitap.alsu.tatar/api/upload_f',
            headers: {
                'Access-Control-Allow-Origin': '*',
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                path: new Date().getTime()
            },
            data: data
        };

        let answer = await axios(config)
            .catch(function (error) {
                console.log(error);
            });
        setLoader(false)
        return answer.data

    };

    return (
        <div>
            <Stack direction={'horizontal'}>
                <Stack className={'mr-4'} style={{
                    backgroundColor: '#efefef',
                    minHeight: '96vh',
                    margin: 20,
                    borderRadius: 5,
                    padding: 20,
                    maxWidth: '45%'
                }}>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Обложка</th>
                            <th>Опубликовано</th>
                            <th>Название</th>
                            <th>Действия</th>
                        </tr>
                        </thead>
                        <tbody>

                        {books.map((book, index) => (
                            <tr>
                                <td>{index + 1}</td>
                                <td><img src={'http://kitap.alsu.tatar' + book.cover} width={48}/>
                                </td>
                                <td>{book.approved ? 'Да' : 'Нет'}</td>

                                <td>{book.title}</td>
                                <td style={{width: '20%', textAlign: 'center', verticalAlign: 'middle'}}>
                                    {/*@ts-ignore*/}
                                    <Button onClick={() => editItem(index)} style={{
                                        backgroundColor: 'rgba(10,133,49,0.78)',
                                        color: 'white',
                                        padding: 9,
                                        borderRadius: 5,
                                        borderWidth: 1,
                                        marginRight: 5,
                                        marginTop: 5,
                                        textDecoration: 'none',
                                        borderColor: '#333'
                                    }}>Редактировать</Button>
                                    <Button onClick={() => deleteBook(book._id)}
                                            style={{backgroundColor: '#ff0000'}}>Удалить</Button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Stack>
                <Stack
                    style={{minHeight: '96vh', backgroundColor: '#dfdfdf', margin: 40, padding: 20, borderRadius: 5}}>
                    <Card style={{backgroundColor: 'transparent', borderWidth: 0}}>
                        <Card.Text style={{backgroundColor: 'transparent'}}>
                            <Stack direction={'horizontal'}>
                                <Stack style={{maxWidth: '35%'}}>
                                    <Form.Check
                                        size={20}
                                        checked={bookForSave.approved}
                                        label={'Опубликовано'}
                                        onChange={(e) => {
                                            console.log('switch', e);
                                            setBookForSave({...bookForSave, approved: e.target.checked})
                                        }}
                                    />
                                    <Form.Control ref={editorRef} value={bookRawView} as="textarea" rows={25}
                                                  onChange={(e) => changeRawData(e.target.value)}></Form.Control>
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Автор"
                                        style={{width: '100%', marginTop: 20}}
                                    >
                                        <Form.Control onChange={(e) => {
                                            setBookForSave({...bookForSave, author: e.target.value})
                                        }} value={bookForSave?.author}></Form.Control>
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Название"
                                        style={{width: '100%', marginBottom: 20}}
                                    >

                                        <Form.Control value={bookForSave?.title} onChange={(e) => {
                                            setBookForSave({...bookForSave, title: e.target.value})
                                        }}></Form.Control></FloatingLabel>
                                    {bookForSave && bookForSave.cover && (
                                        <>
                                            <span><b>Обложка:</b> {bookForSave.cover}</span>
                                            <span><b>Название:</b> {bookForSave.audio.title}</span>
                                            <span><b>Текст:</b> {bookForSave.audio.body}</span>
                                        </>
                                    )}
                                    <div className="input-group custom-file-button">
                                        <label className="input-group-text" htmlFor="inputGroupFileCover">Обложка</label>
                                        <input onChange={(e) => saveFileToStorage(e, 'cover')} type="file"
                                               className="form-control" id="inputGroupFileCover"/>
                                    </div>
                                    <div className="input-group custom-file-button">
                                        <label className="input-group-text" htmlFor="inputGroupFileTitle">mp3
                                            название</label>
                                        <input onChange={(e) => saveFileToStorage(e, 'title')} type="file"
                                               className="form-control" id="inputGroupFileTitle"/>
                                    </div>
                                    <div className="input-group custom-file-button">
                                        <label className="input-group-text" htmlFor="inputGroupFileBody">mp3 текст</label>
                                        <input onChange={(e) => saveFileToStorage(e, 'body')} type="file"
                                               className="form-control" id="inputGroupFileBody"/>
                                    </div>
                                    <Button style={{backgroundColor: '#4a01f3', marginTop: 20}}
                                            onClick={saveBook}>Cохранить</Button>
                                </Stack>

                                <Stack>
                                    {Array.isArray(bookRaw) && (
                                        <>
                                            <Stack style={{marginLeft: 20}} direction={'horizontal'}>
                                                <Button onClick={() => setCurrentMode('words')} style={{
                                                    width: '50%',
                                                    borderRadius: 0,
                                                    backgroundColor: currentMode === 'words' ? '#0d6efd' : '#666'
                                                }}>Слова</Button>
                                                <Button onClick={() => setCurrentMode('tests')} style={{
                                                    width: '50%',
                                                    borderRadius: 0,
                                                    backgroundColor: currentMode === 'tests' ? '#0d6efd' : '#666'
                                                }}>Тесты</Button>
                                            </Stack>
                                            {currentMode === 'words' && (
                                                <>
                                                    {bookRaw.map((string, idx) => (
                                                        <Card style={{
                                                            backgroundColor: '#fff',
                                                            minHeight: 200,
                                                            padding: 10,
                                                            margin: 10
                                                        }}>
                                                            <Stack direction={'horizontal'}>
                                                                <Form.Control value={string.word} onChange={(e) => {
                                                                    let tmp = bookForSave.karaoke
                                                                    tmp[idx].word = e.target.value
                                                                    setBookForSave({...bookForSave, karaoke: tmp})
                                                                    tmp = bookRaw
                                                                    tmp[idx].word = e.target.value
                                                                    setBookRaw(tmp)
                                                                }}/>
                                                                <Form.Control value={string.start}
                                                                              onChange={(e) => {
                                                                                  let tmp = bookForSave.karaoke
                                                                                  tmp[idx].start = e.target.value
                                                                                  setBookForSave({
                                                                                      ...bookForSave,
                                                                                      karaoke: tmp
                                                                                  })
                                                                                  tmp = bookRaw
                                                                                  tmp[idx].start = e.target.value
                                                                                  setBookRaw(tmp)
                                                                              }}
                                                                />
                                                                <Form.Check checked={string.end} onChange={(e) => {
                                                                    let tmp = bookRaw
                                                                    tmp[idx].end = e.target.checked
                                                                    setBookForSave({...bookForSave, karaoke: tmp})
                                                                }}/>
                                                            </Stack>
                                                            <ReactQuill theme="snow" value={string?.description}
                                                                        onChange={(e) => {
                                                                            let tmp = bookRaw
                                                                            tmp[idx].description = e
                                                                            setBookForSave({
                                                                                ...bookForSave,
                                                                                karaoke: tmp
                                                                            })
                                                                        }}/>
                                                        </Card>
                                                    ))}
                                                </>
                                            )}
                                            {currentMode === 'tests' && (
                                                <>
                                                    {bookForSave.test.map((test, qIdx) => (
                                                        <Card style={{width: '100%', margin: 20, padding: 20}}>
                                                            <Form.FloatingLabel label={'Вопрос'}>
                                                                <Form.Control onChange={(e) => {
                                                                    let tmp = bookForSave.test
                                                                    tmp[qIdx].question = e.target.value
                                                                    setBookForSave({...bookForSave, test: tmp})
                                                                }} value={test.question}/>
                                                                {test.answers.map((answer, aIdx) => (
                                                                    <Stack direction={'horizontal'}>
                                                                        <FloatingLabel label={'Ответ' + (aIdx + 1)}
                                                                                       style={{width: '90%'}}>
                                                                            <Form.Control onChange={(e) => {
                                                                                let tmp = bookForSave.test
                                                                                tmp[qIdx].answers[aIdx].answer = e.target.value
                                                                                setBookForSave({
                                                                                    ...bookForSave,
                                                                                    test: tmp
                                                                                })
                                                                            }} value={answer.answer}/>
                                                                        </FloatingLabel>
                                                                        <Form.Check onChange={(e) => {
                                                                            let tmp = bookForSave.test
                                                                            tmp[qIdx].answers[aIdx].correct = e.target.checked
                                                                            setBookForSave({...bookForSave, test: tmp})
                                                                        }} style={{marginLeft: 10}}
                                                                                    checked={answer.correct}/>
                                                                    </Stack>
                                                                ))}
                                                            </Form.FloatingLabel>
                                                        </Card>
                                                    ))}
                                                    <Button onClick={addEmptyQuestion}>+</Button>
                                                </>
                                            )}
                                        </>
                                    )}
                                </Stack>
                            </Stack>
                        </Card.Text>
                    </Card>
                </Stack>
            </Stack>
        </div>
    )
};

export default Karaoke;
